<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :definition="definition"
    :generate-summary="generateSummary"
    :caption="caption"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :permission-code="permissionCode"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    columns: {
      default: () => [{ field: 'description' }],
      type: Array
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    generateSummary(row) {
      return `${row.description}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
